// @ts-nocheck
// Tjekleasing Form Validation
function validateField(field, fieldName) {
  const value = field.value.trim();
  const errorElement = document.getElementById(`error-${fieldName}`);

  // Clear previous error
  clearError(fieldName);

  // Check if field is empty
  if (!value) {
    showError(fieldName, "Dette felt er påkrævet");
    field.classList.add("error");
    return false;
  }

  // Specific validation for different field types
  switch (fieldName) {
    case "email":
      const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
      if (!emailRegex.test(value)) {
        showError(fieldName, "Indtast venligst en gyldig email-adresse");
        field.classList.add("error");
        return false;
      }
      break;

    case "phone":
      const phoneRegex = /^[0-9]{8}$/;
      if (!phoneRegex.test(value)) {
        showError(
          fieldName,
          "Indtast venligst et gyldigt telefonnummer (8 cifre)"
        );
        field.classList.add("error");
        return false;
      }
      break;

    case "name":
      if (value.length < 2) {
        showError(fieldName, "Navnet skal være mindst 2 tegn langt");
        field.classList.add("error");
        return false;
      }
      break;
  }

  // If validation passes, remove error class
  field.classList.remove("error");
  return true;
}

function validateDocument(field) {
  const file = field.files[0];
  const errorElement = document.getElementById("error-document");
  const fileInfo = document.getElementById("file-info");

  clearError("document");

  if (!file) {
    showError("document", "Vælg venligst en fil");
    field.classList.add("error");
    return false;
  }

  // Check file type
  const allowedTypes = [
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "text/plain",
  ];
  if (!allowedTypes.includes(file.type)) {
    showError("document", "Filen skal være en PDF, DOC, DOCX eller TXT fil");
    field.classList.add("error");
    return false;
  }

  // Check file size (max 10MB)
  const maxSize = 10 * 1024 * 1024; // 10MB
  if (file.size > maxSize) {
    showError("document", "Filen må ikke være større end 10MB");
    field.classList.add("error");
    return false;
  }

  // Show file info
  fileInfo.textContent = `Valgt fil: ${file.name} (${(
    file.size /
    1024 /
    1024
  ).toFixed(2)} MB)`;
  fileInfo.classList.add("success");

  field.classList.remove("error");
  return true;
}

function showError(fieldName, message) {
  const errorElement = document.getElementById(`error-${fieldName}`);
  if (errorElement) {
    errorElement.textContent = message;
    errorElement.style.display = "block";
  }
}

function clearError(fieldName) {
  const errorElement = document.getElementById(`error-${fieldName}`);
  if (errorElement) {
    errorElement.style.display = "none";
    errorElement.textContent = "";
  }

  // Remove error class from the field
  const field = document.getElementById(fieldName);
  if (field) {
    field.classList.remove("error");
  }
}

function validateForm() {
  let isValid = true;

  // Validate name
  const nameField = document.getElementById("name");
  if (!validateField(nameField, "name")) {
    isValid = false;
  }

  // Validate document
  const documentField = document.getElementById("document");
  if (!validateDocument(documentField)) {
    isValid = false;
  }

  // Validate email
  const emailField = document.getElementById("email");
  if (!validateField(emailField, "email")) {
    isValid = false;
  }

  // Validate phone
  const phoneField = document.getElementById("phone");
  if (!validateField(phoneField, "phone")) {
    isValid = false;
  }

  // Validate email permission (altid påkrævet)
  const emailPermissionCheckbox = document.getElementById(
    "tjekleasingEmailPermission"
  );
  const emailPermissionError = document.getElementById(
    "error-tjekleasingEmailPermission"
  );

  if (!emailPermissionCheckbox?.checked) {
    if (emailPermissionError) {
      emailPermissionError.textContent =
        "Du skal acceptere at modtage email kommunikation";
      emailPermissionError.style.display = "block";
    }
    isValid = false;
  }

  return isValid;
}

// Global function to clear email permission error
function clearTjekleasingEmailPermissionError() {
  const errorElement = document.getElementById(
    "error-tjekleasingEmailPermission"
  );
  if (errorElement) {
    errorElement.textContent = "";
    errorElement.style.display = "none";
  }
}

// Form submission
document.addEventListener("DOMContentLoaded", function () {
  const form = document.getElementById("tjekleasingForm");
  if (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();

      if (!validateForm()) {
        // Scroll to first error
        const firstError = document.querySelector(
          '.error-message[style*="block"]'
        );
        if (firstError) {
          firstError.scrollIntoView({ behavior: "smooth", block: "center" });
        }
        return;
      }

      // Show loading state
      const submitBtn = document.getElementById("submitBtn");
      const submitText = document.getElementById("submitText");
      const loadingText = document.getElementById("loadingText");

      submitBtn.disabled = true;
      submitText.style.display = "none";
      loadingText.style.display = "inline";

      // Prepare form data
      const documentFile = document.getElementById("document").files[0];
      const email = document.getElementById("email").value;
      const phone = document.getElementById("phone").value;
      const name = document.getElementById("name").value;

      // Create FormData object for n8n webhook
      const formData = new FormData();
      formData.append("field-0", documentFile);
      formData.append("field-1", email);
      formData.append("field-2", name);
      formData.append("field-3", phone);

      // Send to n8n webhook first
      fetch(
        "https://carzilla.app.n8n.cloud/form/1c0e24d2-8cfc-4a2e-be17-dbe6ea9153f5",
        {
          method: "POST",
          body: formData,
        }
      )
        .then((response) => {
          if (response.ok) {
            // Also save to our database
            return fetch("/api/contact/tjekleasing-lead", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                name: name,
                email: email,
                phone: phone,
                documentFileName: documentFile.name,
              }),
            });
          } else {
            throw new Error("Webhook response was not ok");
          }
        })
        .then((response) => {
          if (response && response.ok) {
            // Show success message
            document.getElementById("tjekleasingForm").style.display = "none";
            document.getElementById("successMessage").style.display = "block";

            // Scroll to success message
            document
              .getElementById("successMessage")
              .scrollIntoView({ behavior: "smooth", block: "center" });
          } else {
            throw new Error("Database save failed");
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          alert(
            "Der opstod en fejl ved afsendelse af formularen. Prøv venligst igen."
          );

          // Reset button state
          submitBtn.disabled = false;
          submitText.style.display = "inline";
          loadingText.style.display = "none";
        });
    });

    console.log("Tjekleasing form initialized");
  }
});
